(function () {
    const init = () => {
        if (appConfig.lang === 'ua') {
            import('./desktop-ua');
        } else {
            import('./desktop-ru');
        }
    };

    if (document.readyState === 'complete' || document.readyState === 'interactive') {
        // Call on next available tick
        setTimeout(init, 1);
    } else {
        document.addEventListener('DOMContentLoaded', init);
    }
})();
